var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconName)?_c('svg',{staticClass:"svg-icon",class:_vm.iconClasses},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":_vm.iconName}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }